<script lang="ts">
  import { loc } from "module/utils";
  import type {
    SearchResultItemProps,
    SlashCommand,
  } from "../SearchControllers";

  let { resultItem, selected, callAction }: SearchResultItemProps = $props();

  let item = resultItem.item as SlashCommand;
</script>

<li class:search-selected={selected} class="no-icon-result">
  <a onclick={() => callAction({ item })}>
    <span>{item.commandText} {item.args || ""}</span>
    {#if item.description}
      <span>{loc(item.description)}</span>
    {/if}
  </a>
</li>

<style>
  a {
    padding: 4px;
  }
</style>
